<template>
    <b-card :title="title">
        <b-card-header>
            <b-row>
                <b-col>
                    <b-form-group v-slot="{ ariaDescribedby }">
                        <b-form-radio-group
                            id="selectionType"
                            v-model="isOfficerSection"
                            :aria-describedby="ariaDescribedby"
                            name="isOfficerSection"
                        >
                            <b-form-radio :value="false"
                                >By Location</b-form-radio
                            >
                            <b-form-radio :value="true"
                                >By Officer</b-form-radio
                            >
                        </b-form-radio-group>
                    </b-form-group>
                </b-col>

                <b-col v-show="isOfficerSection">
                    <b-form-select
                        id="input-1"
                        v-model="user_id"
                        :options="users"
                        value-field="id"
                        text-field="name"
                        block
                    >
                        <template #first>
                            <b-form-select-option :value="null" disabled>
                                Officer
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>

                <b-col v-show="!isOfficerSection">
                    <b-form-select
                        id="input-location"
                        v-model="location_id"
                        :options="locations"
                        value-field="id"
                        text-field="name"
                        block
                    >
                        <template #first>
                            <b-form-select-option :value="null" disabled>
                                Select Warehouse
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>

                <b-col v-show="!isOfficerSection">
                    <b-form-select
                        id="input-section"
                        v-model="section_id"
                        :options="sections"
                        value-field="id"
                        text-field="name"
                        block
                    >
                        <template #first>
                            <b-form-select-option :value="null" disabled>
                                Select Section
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
            </b-row>
        </b-card-header>
        <b-card-body>
            <b-table
                :fields="itemFields"
                striped
                hover
                responsive
                :items="sectionMasterItems"
            >
            </b-table>
        </b-card-body>
    </b-card>
</template>

<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'SectionItems-ListItems',
    props: ['type', 'title'],
    mixins: [popupMixins, permissionsMixins],

    data() {
        return {
            isOfficerSection: false,
            section_id: null,
            location_id: null,
            user_id: null,
            itemFields: [
                'name',

                {
                    key: 'ext_reference_code',
                    label: 'Code',
                },
                {
                    key: 'order_item_type_id',
                    label: 'Type',
                    formatter: (value, key, item) =>
                        item.type && item.type.name,
                },
                {
                    key: 'vendor_id',
                    label: 'Vendor',
                    formatter: (value, key, item) =>
                        item.vendor && item.vendor.name,
                },

                {
                    key: 'ext_reference_code',
                    label: 'Code',
                    formatter: (value, key, item) => item.ext_reference_code,
                },

                {
                    key: 'uom',
                    label: 'UOM',
                    formatter: (value, key, item) => item.uom,
                },
                {
                    key: 'selling_price',
                    label: 'Price',
                    formatter: (value, key, item) => item.selling_price,
                },
                {
                    key: 'quantity',
                    label: 'Quantity',
                },
            ],
        }
    },

    computed: {
        locations() {
            return this.$store.state.locations.locations.filter(
                x => x.is_warehouse && x.sections.some(y => !y.is_officer)
            )
        },
        sections() {
            const { location_id } = this
            return (
                (
                    this.$store.state.locations.locations.find(
                        x => x.id == location_id
                    ) || {}
                ).sections || []
            ).filter(x => !x.is_officer)
        },
        sectionMasterItems() {
            const $this = this
            const _items = this.$store.state.masterItem.section_items.map(x => {
                x.quantity = $this.getSectionQuantity(
                    x.sections,
                    this.section_id
                )
                return x
            })
            console.log('master items', _items)

            return _items.filter(x => x.quantity !== 0)
        },

        users() {
            return this.$store.getters['users/all_admin_users'].map(x => {
                x.name = x.first_name + ' ' + x.last_name
                return x
            })
        },

        types() {
            return this.$store.state.itemType.items.filter(x => !x.is_discount)
        },
    },
    watch: {
        user_id: function (id) {
            const user = this.users.find(x => x.id == id)
            if (user) this.section_id = user.location_section_id
            else this.section_id = null
            console.log('this.section_id', this.section_id)
        },

        section_id: function (id) {
            console.log('id', id)
            if (id) this.$store.dispatch('masterItem/fetchBySection', id)
            else this.$store.commit('masterItem/SET_SECTION_ITEMS', [])
        },

        isOfficerSection: function () {
            this.section_id = null
            this.location_id = null
            this.user_id = null
        },
    },

    created() {
        this.$store.dispatch('itemType/fetchAll')
        this.$store.dispatch('locations/fetchWarehouses')
        this.$store.dispatch('assets/listVendors')
        this.$store.dispatch('users/fetchAll')
    },

    methods: {
        getSectionQuantity(sections, section_id) {           
            sections = sections || []
            if (section_id) {
                const section = sections.find(
                    x => x.location_section_id === section_id
                )
                if (!section) return 0
                return section.quantity_on_hand
            } else {
                return sections.reduce((_sum, section) => {
                    _sum += section.quantity_on_hand
                }, 0)
            }
        },
    },
}
</script>
<style></style>
